var app = angular.module('leonardo');

var ValidateEmail = function() {
  var EMAIL_REGEXP = /^[a-z0-9!-?A-Z_\u00A1-\u017F]+@[a-z0-9-]+(\.[a-z0-9-]+)*$/;


  return {
    require: 'ngModel',
    restrict: '',
    link: function(scope, elm, attrs, ctrls) {
      scope.ngModelCtrl = ctrls;
      // only apply the validator if ngModel is present
      if (scope.ngModelCtrl && scope.ngModelCtrl.$validators.email) {

        // this will overwrite the default email validator
        scope.ngModelCtrl.$validators.email = function(modelValue) {
          return scope.ngModelCtrl.$isEmpty(modelValue) || EMAIL_REGEXP.test(modelValue);
        };
      }
    }
  };
}
app.directive('validateEmail', [ValidateEmail]);
